import { render, staticRenderFns } from "./TableauxGestion.vue?vue&type=template&id=9f2fff98&"
import script from "./TableauxGestion.vue?vue&type=script&lang=js&"
export * from "./TableauxGestion.vue?vue&type=script&lang=js&"
import style0 from "./TableauxGestion.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports